/**
 * ContextMenu — portal-rendered rename/delete menu triggered from
 * the sidebar's "•••" buttons on projects and chats.
 *
 * Phase E1: extracted from Sidebar.tsx.
 */

import { createPortal } from 'react-dom';
import { FileEdit, Pencil, Trash2 } from 'lucide-react';
import type { ContextMenuTarget } from './types';
import { GLOSSARY } from '../../../modules/mentorship/glossary';

type Props = {
    target: ContextMenuTarget;
    onEditProject: () => void;
    onRename: () => void;
    onDelete: () => void;
};

export default function ContextMenu({ target, onEditProject, onRename, onDelete }: Props) {
    return createPortal(
        <div
            className="context-menu"
            style={{ top: target.y, left: target.x }}
            onMouseDown={(e) => e.stopPropagation()}
        >
            {/* eslint-disable-next-line chiefy/no-naked-concept-strings -- discriminator value for ContextMenuTarget union (infrastructure id), not user copy. */}
            {target.type === 'project' && (
                <button
                    type="button"
                    className="context-menu-item"
                    onClick={onEditProject}
                >
                    <FileEdit size={14} />
                    Edit {GLOSSARY.PROJECT.shortLabel}
                </button>
            )}
            <button type="button" className="context-menu-item" onClick={onRename}>
                <Pencil size={14} />
                Rename
            </button>
            <button type="button" className="context-menu-item danger" onClick={onDelete}>
                <Trash2 size={14} />
                Delete
            </button>
        </div>,
        document.body,
    );
}
